
export default function leave_type( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_LEAVETYPE':
			return action.leave_type
		case 'GET_LEAVETYPE':
			return action.leave_type
		case 'DELETE_LEAVETYPE':
			return action.leave_type
		case 'GET_BY_ID_LEAVETYPE':
			return action.leave_type
		case 'EDIT_LEAVETYPE':
			return action.leave_type
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/leave_type/leave_type.reducer.js